/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type AuthRole = (typeof AuthRole)[keyof typeof AuthRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthRole = {
  RoleAdmin: 'admin',
  RoleUser: 'user',
} as const;
